import { render, staticRenderFns } from "./serviceStyle.vue?vue&type=template&id=5528cba0&scoped=true&"
import script from "./serviceStyle.vue?vue&type=script&lang=js&"
export * from "./serviceStyle.vue?vue&type=script&lang=js&"
import style0 from "./serviceStyle.vue?vue&type=style&index=0&id=5528cba0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5528cba0",
  null
  
)

export default component.exports